var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.43h16.34l-7.453 7.253L10.24 19 20 9.5 10.24 0 8.887 1.315 16.34 8.57H0v1.86z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAyMCAxOSIgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0wIDEwLjQzMDRMMTYuMzM5NiAxMC40MzA0TDguODg3MjcgMTcuNjgzM0wxMC4yNDAxIDE5TDIwIDkuNUwxMC4yNDAxIDBMOC44ODcyNyAxLjMxNDkxTDE2LjMzOTYgOC41Njk1OUwwIDguNTY5NTlWMTAuNDMwNFoiIC8+Cjwvc3ZnPgo=";
export { SvgArrow as ReactComponent };